import React, { createContext, useContext, useState, useCallback } from 'react';
import { TabItem } from '../components/layout/TabsManager';

interface TabsContextType {
  tabs: TabItem[];
  activeKey: string;
  addTab: (tab: TabItem) => void;
  removeTab: (key: string) => void;
  setActiveKey: (key: string) => void;
}

const TabsContext = createContext<TabsContextType | undefined>(undefined);

export const TabsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [tabs, setTabs] = useState<TabItem[]>([]);
  const [activeKey, setActiveKey] = useState<string>('');

  const addTab = useCallback((tab: TabItem) => {
    setTabs(prev => {
      if (!prev.find(t => t.key === tab.key)) {
        return [...prev, tab];
      }
      return prev;
    });
  }, []);

  const removeTab = useCallback((key: string) => {
    setTabs(prev => prev.filter(tab => tab.key !== key));
  }, []);

  return (
    <TabsContext.Provider value={{ tabs, activeKey, addTab, removeTab, setActiveKey }}>
      {children}
    </TabsContext.Provider>
  );
};

export const useTabs = () => {
  const context = useContext(TabsContext);
  if (context === undefined) {
    throw new Error('useTabs must be used within a TabsProvider');
  }
  return context;
}; 